import React, { useEffect, useState } from "react";
import epicBgimg from "./../../assets/images/epic-login-bg.png";
import epicLogo from "./../../assets/images/epic-product-logo.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ENDPOINTS } from "../../js/api/_config";
import axios from "axios";
import { Toast } from "../common/toast/toast";
import Banner from "./banner";
import { verifyToken } from "../../js/api/constants";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [toasts, setToasts] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [apiLoader, setApiLoader] = useState(false);


  const addToast = (message, type, time = 3000) => {
    const id = Date.now();
    setToasts([...toasts, { id, message, type }]);
    setTimeout(() => removeToast(id), time); // Auto-dismiss after 3 seconds
  };

  const removeToast = (id) => {
    setToasts(toasts.filter((toast) => toast.id !== id));
  };

  // Extract the token from the URL
  const getTokenFromUrl = () => {
    const pathSegments = location.pathname.split('/');
    return pathSegments[pathSegments.length - 1]; // Last segment is the token
  };

  const token = getTokenFromUrl();
  const validateFields = () => {
    const newErrors = {};

    if (!password.trim()) {
      newErrors.password = "Password is required";
    } else if (password.length < 8) {
      newErrors.password = "Password must be at least 8 characters long";
    }

    if (!confirmPassword.trim()) {
      newErrors.confirmPassword = "Confirm Password is required";
    } else if (confirmPassword !== password) {
      newErrors.confirmPassword = "Passwords does not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (!validateFields()) return;
    setApiLoader(true)
    const requestBody = {
      password: password, // Replace with the actual password from your form state
      confirmPassword: confirmPassword, // Replace with the actual confirm password from your form state
    };

    try {
      // Simulate API call
      const response = await axios.post(`${ENDPOINTS.PASSWORD.RESET_PASSWORD}/${token}`, requestBody);
      // setMessage("Password reset successfully.");
      setApiLoader(false)
      addToast("Password reset successfully!", "success")
      setErrors({});
      navigate("/login");
    } catch (err) {
      setApiLoader(false)
      addToast(err.response.data.message, "error")
      // console.log('err', err.response.data.message)
      // setMessage("Something went wrong. Please try again.");

    }
  };

  async function verifyToken(data) {
    try {
      const response = await axios.post(`${ENDPOINTS.PASSWORD.VERIFY_RESET_TOKEN}/${data.token}`);
    } catch (error) {
      addToast("your reset password link is expired", "error", 6000)
      setTimeout(() => navigate("/login"), 1000);

      // console.error('Error verifying token:', error.response?.data || error.message);
    }
  }

  useEffect(() => {
    if (token) {
      verifyToken({ token })
    }

  }, [])

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Left Side - Carousel */}
      <Banner />
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          toast={toast}
          onClose={() => removeToast(toast.id)}
        />
      ))}
      {/* Right Side - Reset Password Form */}
      <div className="w-2/3 bg-white flex flex-col justify-center items-center px-8 relative">
        <div className="w-full max-w-[420px]">
          <img src={epicLogo} alt="Logo" className="mb-[60px] mx-auto w-[278px]" />
          <h2 className="text-[32px] font-[600] text-center font-mont mb-[40px]">Set New Password</h2>
          <form className="space-y-4" onSubmit={handleResetPassword}>
            <div>
              <label htmlFor="password" className="block text-sm text-gray-700 text-[16px] font-[600] mb-3">
                New Password
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              {errors.password && <p className="text-red-500 text-sm">{errors.password}</p>}
            </div>

            <div>
              <label htmlFor="confirmPassword" className="block text-sm text-gray-700 text-[16px] font-[600] mb-3">
                Confirm Password
              </label>
              <input
                type="password"
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              {errors.confirmPassword && <p className="text-[#F95454] font-mont text-[14px] font-[500]">{errors.confirmPassword}</p>}
            </div>

            <button
              type="submit"
              className="w-full bg-[#245CEA] text-[#FFFFFF] py-2 rounded hover:bg-blue-600 font-mont font-[600] text-[18px]"
              disabled={apiLoader}>{apiLoader ? <div className="flex justify-center"><div className="mini-spinner"></div></div> : "Reset Password"}

            </button>
          </form>

          <Link
            to="/login"
            className="flex text-xs text-black-100 text-center items-center justify-center w-full mt-4 text-[14px] font-mont font-[500]"
          >

            <div className="h-[14px] mb-1 mr-3"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14 9H4" stroke="#1A1A1B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M9 14.25L3.75 9L9 3.75" stroke="#1A1A1B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg></div>
            Back to Login
          </Link>

          {message && <p className="text-green-500 text-sm mt-2">{message}</p>}
        </div>
        <p className="text-center text-sm text-gray-500 absolute bottom-3">
          &copy; 2025 eClinRecruit. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default ResetPassword;